import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { EventsApi } from "./api";
import { CustomersApi } from "../Customers/api";
import WorkLogGrid from "./WorkLogGrid";

type handler = () => void;
interface jiraReportsInfoProps {
  visible: boolean;
  toggleVisible: handler;
  issue: any;
}

const JiraReportInfo = (props: jiraReportsInfoProps) => {
  const [workLogs, updateWorkLogs] = useState(null);
  const [loadingWorkLogs, updateLoadingWorkLogs] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string>(null);
  const [issue, updateIssue] = useState(null);

  useEffect(() => {
    if (props.issue != null) {
      updateIssue(props.issue);
      if (props.issue.svcCallId != null) {
        fetchWorkLogs(props.issue.svcCallId);
      }
    }
  }, [props.issue]);

  const fetchWorkLogs = (callId: string) => {
    updateLoadingWorkLogs(true);
    updateWorkLogs(null);

    const newParams: any = { issueId: callId };
    EventsApi.getJiraWorkLogs(newParams)
      .then((response: any) => {
        if (response != "canceled") {
         // console.log(response);
          updateLoadingWorkLogs(false);
          updateWorkLogs(response);
        }
        setErrorMessage(null);
      })
      .catch((error) => {
        if (error.message != "canceled") {
          updateLoadingWorkLogs(false);
          setErrorMessage("Oops something went wrong, unable to get data.");
        }
        console.log(error);
      });
  };
  const formatJIRAReportData = function (report: any, customer: any) {
    var reportData: any = {};
    if (report != null) {
      reportData.ReportId = report.eventID;
      reportData.ReportDate = report.created; //need formtting to be like, 'dd.MM.yyyy');
      reportData.CustomerName = customer.customerName;
      reportData.CustomerAddress = customer.street;
      reportData.PoBox = "";
      reportData.CustomerPostalCode = customer.zipCode;
      reportData.CustomerCity = customer.city;
      reportData.CustomerCountry = customer.country;
      reportData.Machine = report.machineSN;
      reportData.ServiceCall = report.svcCallId;
      reportData.ServiceSubject = report.faultDescription;
      reportData.ServicePersonSignature = report.engineer;
     // console.log(reportData);
      var reportEvents: any = [];
      for (var i = 0; i < workLogs.length; i++) {
        var e: any = workLogs[i];
        var reportE: any = {};
        reportE.Date = e.created; //need formtting to be like, 'dd.MM.yyyy');
        reportE.ServicePerson = e.authorName;
        reportE.Description = e.comment;
        var dur = e.timeSpentSeconds / 3600;
        reportE.Duration = dur.toFixed(2) + " h";
        reportEvents.push(reportE);
      }
      reportData.Events = reportEvents;
    }
    return reportData;
  };
  const createPdf = () => {
    let formattedReport: any = {};
    const newParams: any = {
      customerID: issue.customerID,
    };
    CustomersApi.getCustomerInfo(newParams)
      .then((response: any) => {
        if (response != "canceled") {
         // console.log(response);
          formattedReport = formatJIRAReportData(issue, response);

          EventsApi.createJiraPdf({
            data: formattedReport,
            template: { shortid: "ryYXgs2Dl" },
          })
            .then((response: any) => {
              if (response != "canceled") {
                const pdfBlob = new Blob([response], {
                  type: "application/pdf",
                });

                const blobUrl = window.URL.createObjectURL(pdfBlob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", "Jira report " + issue.svcCallId);
                link.click();
                link.remove();
                URL.revokeObjectURL(blobUrl);
                //console.log(response);
                //const url = window.URL.createObjectURL(new Blob([response], { type: "application/pdf" }));
                //const link = document.createElement('a');
                //link.href = url;
                //link.setAttribute('download', 'file.pdf'); //or any other extension
                //document.body.appendChild(link);
                //link.click();
                //var file = new Blob([response.data], { type: 'application/pdf' });
                //// IE 10 / 11
                //if (window.navigator.msSaveOrOpenBlob) {
                //    window.navigator.msSaveOrOpenBlob(file, "report.pdf");
                //} else {
                //    var fileURL = URL.createObjectURL(file);
                //    window.open(fileURL);
                //}
              }
              setErrorMessage(null);
            })
            .catch((error) => {
              if (error.message != "canceled") {
              }
              console.log(error);
            });
        }
      })
      .catch((error) => {
        if (error.message != "canceled") {
        }
        console.log(error);
      });
  };
  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog
          title={"Jira Issue Info"}
          onClose={props.toggleVisible}
          width={600}
        >
          <div style={{ backgroundColor: "#fff", padding: "20px" }}>
            <ul>
              <li>
                <span style={{ fontWeight: "bold" }}>SCM Issue Id: </span>
                {props.issue.svcCallId}
              </li>
              <li>
                <span style={{ fontWeight: "bold" }}>Machine Serial: </span>{" "}
                {props.issue.machineSN}
              </li>
              <li>
                <span style={{ fontWeight: "bold" }}>Subject: </span>
                {props.issue.faultDescription}
              </li>
            </ul>
            <h5>Work Logs</h5>
            <WorkLogGrid data={workLogs} />
          </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={createPdf}
            >
              Open PDF
            </button>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default JiraReportInfo;
